import * as React from 'react';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Card, CardContent, Fade } from '@mui/material';

export type UpdateRowsBannerProps = {
    percentage: number;
    value: number;
    total: number;
};

export const UpdateRowsBanner = ({ percentage, total, value }: UpdateRowsBannerProps) => (
    <Card component={Fade} in={total > 0} sx={{ width: '80%', maxWidth: '300px', position: 'fixed', bottom: 10, right: 10 }} raised>
        <CardContent>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                {percentage > 0 ? 'Updating rows' : ''}
            </Typography>
            {percentage > 0 ? (
                <LinearProgressWithLabel variant="determinate" percentage={percentage} value={value} total={total} />
            ) : (
                <Typography variant="body2" color="text.secondary" textAlign="center">
                    {`Preparing to update ${total} rows, it will take a few seconds...`}
                </Typography>
            )}
        </CardContent>
    </Card>
);

const LinearProgressWithLabel = ({
    value,
    total,
    percentage
}: LinearProgressProps & { percentage: number; value: number; total: number }) => (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress variant="determinate" value={percentage} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="text.secondary">
                {value}/{total}
            </Typography>
        </Box>
    </Box>
);
